import React, { Component } from "react";
import moment from 'moment';
import { connect } from "react-redux";
import util from "library/util";
import { editEliteMembership } from "actions/EntityActions";
import { clearFormInput, formInput } from "actions/FormActions";
import { showSnackbar } from "actions/CommonActions";
// Basic Components
import Button from "screens/components/basic/Button";
import DatePickerCalendarInput from "screens/components/basic/DatePickerCalendarInput";


class EditEliteMembership extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.clearEditMembershipForm();
    }

    componentDidUpdate(prevProps) {
        if (this.props.saveSuccess && this.props.saveSuccess != prevProps.saveSuccess) {
            this.clearEditMembershipForm();
            this.props.showSnackbar("Elite Membership updated successfully!");
        }

        if (this.props.saveError && this.props.saveError != prevProps.saveError) {
            this.props.showSnackbar(`Failed to update Elite Membership: ${this.props.saveError}`);
        }

        if (this.props.isEditEliteMembership && this.props.isEditEliteMembership != prevProps.isEditEliteMembership) {
            this.props.formInput(moment(this.props.eliteMemberStartDate).format('YYYY-MM-DD'), "eliteMemberStartDate")
            this.props.formInput(moment(this.props.eliteMemberEndDate).format('YYYY-MM-DD'), "eliteMemberEndDate")
        }

        if(this.props.eliteMemberStartDate != prevProps.eliteMemberStartDate && this.props.eliteMemberEndDate == prevProps.eliteMemberEndDate){
            const addOneYearToStartDate = moment(this.props.eliteMemberStartDate).add(1, 'year').format('YYYY-MM-DD')
            this.props.formInput(addOneYearToStartDate, "eliteMemberEndDate");
        }
    }

    clearEditMembershipForm = () => {
        this.props.clearFormInput("eliteMemberStartDate")
        this.props.clearFormInput("eliteMemberEndDate")
        this.props.formInput(false, "isEditEliteMembership");
    };

    validateEliteDate(model) {
        const validators = [
            [
                `eliteMemberStartDate`,
                (model) => (model.eliteMemberStartDate && model.eliteMemberStartDate != "" && model.eliteMemberStartDate.length == 10),
                "Start Date"
            ],
            [
                `eliteMemberEndDate`,
                (model) => (model.eliteMemberEndDate && model.eliteMemberEndDate != "" && model.eliteMemberEndDate.length == 10),
                "End Date"
            ],
            [
                `eliteMemberEndDate`,
                (model) => moment(model.eliteMemberEndDate).isAfter(moment(model.eliteMemberStartDate)),
                "#End Date has to be later than Start Date"
            ]
        ];
        return util.validate(validators, model, this.props.formError);
    }

    updateEliteMembership = async () => {
        const model = {
            id: this.props.patientID,
            eliteMemberStartDate: this.props.eliteMemberStartDate,
            eliteMemberEndDate: this.props.eliteMemberEndDate
        };

        if (this.validateEliteDate(model)) {
            this.props.editEliteMembership(model);
        }
    };

    editEliteMembership = () => {
        this.props.formInput(!this.props.isEditEliteMembership, "isEditEliteMembership");
    }

    render() {
        // Minimum and maximum date for elite membership date
        const currentYear = new Date().getFullYear();
        const minDate = `${currentYear - 3}-01-01`;
        const maxDate = `${currentYear + 3}-12-31`;

        return (
            <div>
                <Button
                    name="IconEditButton"
                    type="IconEditButton"
                    label="Edit"
                    onTouchTap={() => this.editEliteMembership()}
                />

                {this.props.isEditEliteMembership ? (
                    <div className="row">
                        <div className="col-lg-6 p-0 pr-2">
                            <DatePickerCalendarInput
                                name="eliteMemberStartDate"
                                floatingLabelText="Elite Member Start Date"
                                fullWidth={true}
                                className="mr-2"
                                min={minDate}
                                max={maxDate}
                                preventTyping={true}
                            />
                        </div>
                        <div className="col-lg-6 p-0">
                            <DatePickerCalendarInput
                                name="eliteMemberEndDate"
                                floatingLabelText="Elite Member End Date"
                                fullWidth={true}
                                min={moment(this.props.eliteMemberStartDate).add(1, 'day').format('YYYY-MM-DD')}
                                max={maxDate}
                                preventTyping={true}
                            />
                        </div>
                        <div className="text-right">       
                            <Button
                                name="Save"
                                label="Save"
                                className="mr-2"
                                primary={true}
                                onTouchTap={() => this.updateEliteMembership()}
                            />
                            <Button
                                name="buttonCancel"
                                className="btnCleanSearch"
                                label="Cancel"
                                onTouchTap={() => this.clearEditMembershipForm()}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        eliteMemberStartDate: state.form["eliteMemberStartDate"] || props.eliteMemberStartDate,
        eliteMemberEndDate: state.form["eliteMemberEndDate"] || props.eliteMemberEndDate,
        isEditEliteMembership: state.form["isEditEliteMembership"],
        saveSuccess: state.entity.saveSuccess,
        saveError: state.entity.saveError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        editEliteMembership: (model) => dispatch(editEliteMembership(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        showSnackbar: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditEliteMembership);
